import { render, staticRenderFns } from "./PasajeroView.vue?vue&type=template&id=2cff40ae&scoped=true"
import script from "./PasajeroView.vue?vue&type=script&lang=js"
export * from "./PasajeroView.vue?vue&type=script&lang=js"
import style0 from "./PasajeroView.vue?vue&type=style&index=0&id=2cff40ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cff40ae",
  null
  
)

export default component.exports